import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { FaUndo } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import { RiSave2Fill } from "react-icons/ri";
import { BsCheck2 } from "react-icons/bs";
import { TbArrowBackUp } from "react-icons/tb";
import { IoExitOutline } from "react-icons/io5";
import axios from "axios";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import {
  Autocomplete,
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import Loader from "../../Shared_Components/Loader";
import { API_HOST } from "../../api_utils";
import { useNavigate } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

// function to handle increments in date based on payment frequency of the loan product:
function moveDate(date, number, unit) {
  const d = new Date(date);
  switch (unit) {
    case "days":
      d.setDate(d.getDate() + number);
      break;
    case "weeks":
      d.setDate(d.getDate() + number * 7);
      break;
    case "months":
      d.setMonth(d.getMonth() + number);
      d.setHours(0, 0, 0, 0); // set time to midnight
      break;
    case "years":
      d.setFullYear(d.getFullYear() + number);
      break;
    default:
      break;
  }
  return d;
}

function Claims(props) {
  let navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const singaporeTimezone = "Asia/Singapore";
  const currentDateInSingapore = new Date().toLocaleDateString("en-US", {
    timeZone: singaporeTimezone,
  });
  const [addClaimData, setAddClaimData] = useState({
    claim_date: formatDate(currentDateInSingapore),
    claim_type: "",
    amount: "",
  });
  function formatDate(dateString) {
    const [month, day, year] = dateString.split("/");
    const formattedMonth = month.padStart(2, "0");
    const formattedDay = day.padStart(2, "0");
    return `${year}-${formattedMonth}-${formattedDay}`;
  }

  const [isClaimAdded, setIsClaimAdded] = useState(false);

  const [openEdit, setOpenEdit] = useState(false);
  const [openOtherReason, setOpenOtherReason] = useState(false);
  const [selectedClaimData, setSelectedClaimData] = useState({});
  const [claimReason, setClaimReason] = useState("");
  const [editClaimSuccess, setEditClaimSuccess] = useState(false);

  const [currentData, setCurrentData] = useState([]);

  // states for filter:
  const [claimType, setClaimType] = useState("");
  const [managerName, setManagerName] = useState("");
  const [agentName, setAgentName] = useState("");
  const [claimAfter, setClaimAfter] = useState("");
  const [claimBefore, setClaimBefore] = useState("");
  const [loginNameFilter, setLoginNameFilter] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(0);
  const [totalAmount, setTotalAmount] = useState("");

  // states for autocomplete
  const [agentNameList, setAgentNameList] = useState([]);
  const [managerNameList, setManagerNameList] = useState([]);
  const [loginNameList, setLoginNameList] = useState([]);
  const [managerNameForApi, setManagerNameForApi] = useState("");
  const [selectedManagerName, setSelectedManagerName] = useState("");
  const [agentNameForApi, setAgentNameForApi] = useState("");
  const [selectedAgentName, setSelectedAgentName] = useState("");
  const [loginNameForApi, setLoginNameForApi] = useState("");
  const [selectedLoginName, setSelectedLoginName] = useState("");
  const searchFilterOptionsShowManager = useRef(true);
  const searchFilterOptionsShowAgent = useRef(true);
  const [reconciliationData, setReconciliationData] = useState([]);
  const [reconciliationDoneToday, setReconciliationDoneToday] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const { userDataFromStorage, coloredTheme } = props;

  const getCashReconciliationList = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/get_cash_plus?page=${currentPage}&pageSize=${pageSize}`;

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (data.message) {
        setLoading(false);
      } else {
        setLoading(false);
        // setManagerAgentCashReconciliationList(data);
        setReconciliationData(data);
      }
    } else {
      setLoading(false);
    }
  };

  const getAllAgentNames = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/agent_name_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      setAgentNameList(data);
    } else {
      setLoading(false);
    }
  };

  const getAllLoginNames = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/get_login_name`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      setLoginNameList(data);
    } else {
      setLoading(false);
    }
  };

  const getAllManagerNames = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/manager_name_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      setManagerNameList(data);
    } else {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      let apiUrl = `${API_HOST}/api/claim/get_claims?page=${currentPage}&pageSize=${pageSize}`;

      const queryParams = [];
      if (claimType) {
        queryParams.push(`claim_type=${claimType}`);
      }
      if (managerNameForApi) {
        queryParams.push(`managerName=${managerNameForApi}`);
      }

      if (agentNameForApi) {
        queryParams.push(`claimerName=${agentNameForApi}`);
      }

      if (loginNameForApi) {
        queryParams.push(`login_name=${loginNameForApi}`);
      }

      if (claimAfter) {
        queryParams.push(`claimAfter=${claimAfter}`);
      }
      if (claimBefore) {
        queryParams.push(`claimBefore=${claimBefore}`);
      }

      if (queryParams.length > 0) {
        const queryString = queryParams.join("&");
        apiUrl += `&${queryString}`;
      }
      const { data } = await axios.get(apiUrl, config);

      setCurrentData(data[0].data);
      setTotalAmount(data[0].totalAmount);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDataCount = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      let apiUrl = `${API_HOST}/api/claim/get_claims_count?page=${currentPage}&pageSize=${pageSize}`;

      const queryParams = [];
      if (claimType) {
        queryParams.push(`claim_type=${claimType}`);
      }
      if (managerNameForApi) {
        queryParams.push(`managerName=${managerNameForApi}`);
      }

      if (agentNameForApi) {
        queryParams.push(`claimerName=${agentNameForApi}`);
      }

      if (loginNameForApi) {
        queryParams.push(`login_name=${loginNameForApi}`);
      }

      if (claimAfter) {
        queryParams.push(`claimAfter=${claimAfter}`);
      }
      if (claimBefore) {
        queryParams.push(`claimBefore=${claimBefore}`);
      }

      if (queryParams.length > 0) {
        const queryString = queryParams.join("&");
        apiUrl += `&${queryString}`;
      }
      const { data } = await axios.get(apiUrl, config);

      setTotalPages(Math.ceil(data[0].totalCount / 20));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDataManager = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      let apiUrl = `${API_HOST}/api/claim/get_claims_manager?page=${currentPage}&pageSize=${pageSize}`;

      const queryParams = [];
      if (claimType) {
        queryParams.push(`claim_type=${claimType}`);
      }
      if (managerNameForApi) {
        queryParams.push(`managerName=${managerNameForApi}`);
      }

      if (agentNameForApi) {
        queryParams.push(`claimerName=${agentNameForApi}`);
      }

      if (claimAfter) {
        queryParams.push(`claimAfter=${claimAfter}`);
      }
      if (claimBefore) {
        queryParams.push(`claimBefore=${claimBefore}`);
      }

      if (loginNameFilter) {
        queryParams.push(`login_name=${loginNameFilter}`);
      }

      if (queryParams.length > 0) {
        const queryString = queryParams.join("&");
        apiUrl += `&${queryString}`;
      }
      const { data } = await axios.get(apiUrl, config);

      setCurrentData(data[0].data);
      setTotalAmount(data[0].totalAmount);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDataManagerCount = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      let apiUrl = `${API_HOST}/api/claim/get_claims_manager_count?page=${currentPage}&pageSize=${pageSize}`;

      const queryParams = [];
      if (claimType) {
        queryParams.push(`claim_type=${claimType}`);
      }
      if (managerNameForApi) {
        queryParams.push(`managerName=${managerNameForApi}`);
      }

      if (agentNameForApi) {
        queryParams.push(`claimerName=${agentNameForApi}`);
      }

      if (claimAfter) {
        queryParams.push(`claimAfter=${claimAfter}`);
      }
      if (claimBefore) {
        queryParams.push(`claimBefore=${claimBefore}`);
      }

      if (loginNameFilter) {
        queryParams.push(`login_name=${loginNameFilter}`);
      }

      if (queryParams.length > 0) {
        const queryString = queryParams.join("&");
        apiUrl += `&${queryString}`;
      }
      const { data } = await axios.get(apiUrl, config);

      setTotalPages(Math.ceil(data[0].totalCount / 20));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (userDataFromStorage.user_role === "admin") {
      fetchData();
      fetchDataCount();
    } else {
      fetchDataManager();
      fetchDataManagerCount();
    }

    return () => {
      setEditClaimSuccess(false);
      setIsClaimAdded(false);
    };
  }, [isClaimAdded, editClaimSuccess, currentPage]);

  useEffect(() => {
    getAllAgentNames();
    getAllLoginNames();
    getAllManagerNames();
    getCashReconciliationList();
  }, []);

  const addClaimHandler = async () => {
    if (
      addClaimData.claim_date &&
      addClaimData.claim_type &&
      addClaimData.amount
    ) {
      setLoading(true);
      const claimDate = new Date(addClaimData.claim_date);
      const startDate = moveDate(new Date(), -6, "months");
      const endDate = new Date();
      console.log("claimDate", claimDate);
      console.log("startDate", startDate);
      console.log("endDate", endDate);
      if (claimDate >= startDate && claimDate <= endDate) {
        console.log("claimDate", claimDate);
        console.log("startDate", startDate);
        console.log("endDate", endDate);
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userDataFromStorage.token}`,
          },
        };

        const payload = {
          ...addClaimData,
          claim_reason: claimReason ? claimReason : null,
        };

        const { data } = await axios.post(
          `${API_HOST}/api/claim/add_claim`,
          payload,
          config
        );
        if (data) {
          if (data.message) {
            setLoading(false);
            toast.error(data.message);
          } else {
            setLoading(false);
            setClaimReason("");
            toast.success("Claim Details Added Successfully !!!");
            setIsClaimAdded(true);
            setOpen(false);
          }
        } else {
          toast.error("Something Went Wrong !!!");
        }
      } else {
        toast.warn("Claim Can Be Field Since Last 6 Months Till Now !!!");
      }
    } else {
      toast.warn("Make Sure to Fill All Fields");
    }
  };

  const editClaimHandler = async () => {
    const claimDate = new Date(selectedClaimData.claim_date);
    const startDate = moveDate(new Date(), -6, "months");
    const endDate = new Date();

    if (claimDate >= startDate && claimDate <= endDate) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      const payload = {
        ...selectedClaimData,
        claim_reason: claimReason ? claimReason : null,
      };

      const { data } = await axios.put(
        `${API_HOST}/api/claim/update_claim`,
        payload,
        config
      );
      if (data) {
        if (data.message) {
          setLoading(false);
          toast.error(data.message);
        } else {
          setLoading(false);
          toast.success("Claim Details Updated Successfully !!!");
          setEditClaimSuccess(true);
          setOpenEdit(false);
        }
      } else {
        toast.error("Something Went Wrong !!!");
      }
    } else {
      toast.warn("Claim Can Be Field Since Last 6 Months Till Now !!!");
    }
  };

  useEffect(() => {
    if (userDataFromStorage.user_role === "admin") {
      fetchData();
      fetchDataCount();
    } else {
      fetchDataManager();
      fetchDataManagerCount();
    }
  }, [managerNameForApi, agentNameForApi, claimType, claimAfter, claimBefore]);

  const handleManagerNameChange = useCallback((e) => {
    setManagerName(e.target.value);
  }, []);

  const filteredManagerOptions = useMemo(() => {
    if (managerName && !selectedManagerName) {
      console.log("here");
      const searchTerm = managerName.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      managerNameList.forEach((option) => {
        if (
          option.manager_name &&
          option.manager_name.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.manager_name.toLowerCase().startsWith(searchTerm)",
            option.manager_name.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.manager_name.localeCompare(b.manager_name, undefined, {
          sensitivity: "base",
        })
      );

      console.log(
        "optionsStartingWithSearchTerm",
        optionsStartingWithSearchTerm
      );

      // setAgentLastName("");

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here agent");
      if (selectedManagerName) {
        setManagerNameForApi(selectedManagerName);
        setSelectedManagerName("");

        searchFilterOptionsShowManager.current = false;
      } else {
        searchFilterOptionsShowManager.current = true;
      }

      return [];
    }
  }, [managerName, selectedManagerName]);

  const handleAgentNameChange = useCallback((e) => {
    setAgentName(e.target.value);
  }, []);

  const handleLoginNameChange = useCallback((e) => {
    setLoginNameFilter(e.target.value);
  }, []);

  const filteredAgentOptions = useMemo(() => {
    if (agentName && !selectedAgentName) {
      console.log("here");
      const searchTerm = agentName.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      agentNameList.forEach((option) => {
        if (
          option.agent_name &&
          option.agent_name.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.agent_name.toLowerCase().startsWith(searchTerm)",
            option.agent_name.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.agent_name.localeCompare(b.agent_name, undefined, {
          sensitivity: "base",
        })
      );

      console.log(
        "optionsStartingWithSearchTerm",
        optionsStartingWithSearchTerm
      );

      // setAgentLastName("");

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here agent");
      if (selectedAgentName) {
        console.log("here agent1111");
        setAgentNameForApi(selectedAgentName);
        setSelectedAgentName("");

        searchFilterOptionsShowAgent.current = false;
      } else {
        console.log("here agent222");
        searchFilterOptionsShowAgent.current = true;
      }

      return [];
    }
  }, [agentName, selectedAgentName]);

  const filteredLoginOptions = useMemo(() => {
    if (loginNameFilter && !selectedLoginName) {
      const searchTerm = loginNameFilter.toLowerCase();
      const optionsStartingWithSearchTerm = loginNameList.filter(
        (option) =>
          option.login_name &&
          option.login_name.toLowerCase().startsWith(searchTerm)
      );

      const optionsContainingSearchTerm = loginNameList.filter(
        (option) =>
          option.login_name &&
          option.login_name.toLowerCase().includes(searchTerm) &&
          !option.login_name.toLowerCase().startsWith(searchTerm)
      );

      return [...optionsStartingWithSearchTerm, ...optionsContainingSearchTerm];
    } else {
      setLoginNameForApi(selectedLoginName);
      setSelectedLoginName("");

      return [];
    }
  }, [loginNameFilter]);

  function setToMidnight(date) {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
  }

  useEffect(() => {
    if (
      userDataFromStorage.user_role === "agent" ||
      userDataFromStorage.user_role === "senior_agent"
    ) {
      if (reconciliationData.length) {
        if (
          setToMidnight(reconciliationData[0].last_reconciliation).getTime() ===
          setToMidnight(new Date()).getTime()
        ) {
          setReconciliationDoneToday(true);
        }
      }
    }
  }, [reconciliationData]);

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden"
      }>
      <p className="text-gray-800 md:text-[1.8rem] text-[1.3rem] tracking-wider">
        Claim Overview
      </p>

      {/* search field */}
      <div className="bg-white">
        <p
          style={{ backgroundColor: coloredTheme }}
          className=" text-white px-[0.5rem] py-[1rem] mt-6">
          Search Fields
        </p>
        <div className="py-[1rem] px-[0.5rem]">
          {userDataFromStorage.user_role === "admin" && (
            <div className="relative md:flex justify-start items-center mt-6">
              <p className="w-[30%]">Manager Last Name</p>
              <input
                type="text"
                value={managerName}
                placeholder="Enter Manager Last Name"
                onInput={(e) => {
                  console.log("e.target::::::", e.target.value);
                  handleManagerNameChange(e);
                }}
                className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
              />
              {filteredManagerOptions.length > 0 && (
                <div
                  className={
                    searchFilterOptionsShowManager?.current
                      ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                      : "hidden"
                  }>
                  {filteredManagerOptions.map((option, index) => (
                    <div
                      className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                      onClick={() => {
                        setSelectedManagerName(option.manager_name);
                        setManagerName(option.manager_name);
                      }}
                      key={index}>
                      {option.manager_name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* {userDataFromStorage.user_role === "manager" ||
            (userDataFromStorage.user_role === "admin" && (
              <div className="relative md:flex justify-start items-center mt-6">
            <p className="w-[30%]">Claimer Login Name</p>
            <input
              type="text"
              value={loginNameFilter}
              placeholder="Enter Claimer Login Name"
              onInput={(e) => {
                console.log("e.target::::::", e.target.value);
                handleLoginNameChange(e);
              }}
              className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
            />
            {filteredLoginOptions.length > 0 && (
              <div className="absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10">
                {filteredLoginOptions.map((option) => (
                  <div
                    className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                    onClick={() => {
                      setSelectedLoginName(option.login_name);
                      setLoginNameFilter(option.login_name);
                    }}
                    key={option.login_name}>
                    {option.login_name}
                  </div>
                ))}
              </div>
            )}
          </div>
            ))} */}

          {userDataFromStorage.user_role === "admin" ||
          userDataFromStorage.user_role === "manager" ? (
            <div className="relative md:flex justify-start items-center mt-6">
              <p className="w-[30%]">Claimer Last Name</p>
              <input
                type="text"
                value={agentName}
                placeholder="Enter Claimer Last Name"
                onInput={(e) => {
                  console.log("e.target::::::", e.target.value);
                  handleAgentNameChange(e);
                }}
                className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
              />
              {filteredAgentOptions.length > 0 && (
                <div
                  className={
                    searchFilterOptionsShowAgent.current === true
                      ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                      : "hidden"
                  }>
                  {filteredAgentOptions.map((option, index) => (
                    <div
                      className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                      onClick={() => {
                        console.log("option.agent_name::", option.agent_name);
                        setAgentName(option.agent_name);
                        setSelectedAgentName(option.agent_name);
                      }}
                      key={index}>
                      {option.agent_name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            ""
          )}
          <div className="md:flex justify-start items-center mt-6">
            <p className="w-[25rem]">Claim Made After</p>
            <input
              type="date"
              value={claimAfter}
              onChange={(e) => setClaimAfter(e.target.value)}
              className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
            />
          </div>

          <div className="md:flex justify-start items-center mt-6">
            <p className="w-[25rem]">Claim Made Before</p>
            <input
              type="date"
              value={claimBefore}
              onChange={(e) => setClaimBefore(e.target.value)}
              className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
            />
          </div>

          <div className="md:flex justify-start items-center mt-6">
            <p className="md:w-[25rem]">Claim Type</p>
            <div className="mt-2 md:mt-0  ">
              {/* meals,mileage,mobile,cop,stationary,salary,other */}
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={claimType}
                  name="radio-buttons-group"
                  onChange={(e) => setClaimType(e.target.value)}
                  row>
                  <FormControlLabel
                    value={"Meals"}
                    control={<Radio />}
                    label="Meals"
                  />
                  <FormControlLabel
                    value={"Mileage"}
                    control={<Radio />}
                    label="Mileage"
                  />
                  <FormControlLabel
                    value={"Mobile"}
                    control={<Radio />}
                    label="Mobile"
                  />
                  <FormControlLabel
                    value={"Cop"}
                    control={<Radio />}
                    label="Cop"
                  />
                  <FormControlLabel
                    value={"Stationary"}
                    control={<Radio />}
                    label="Stationary"
                  />
                  <FormControlLabel
                    value={"Salary"}
                    control={<Radio />}
                    label="Salary"
                  />
                  <FormControlLabel
                    value={"Other"}
                    control={<Radio />}
                    label="Other"
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
          <div className="mt-6 flex justify-start items-center space-x-2">
            <button
              onClick={() => {
                setClaimAfter("");
                setClaimBefore("");
                setAgentName("");
                setManagerName("");
                setClaimType("");
                setAgentNameForApi("");
                setManagerNameForApi("");
              }}
              style={{ backgroundColor: coloredTheme }}
              className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem]  text-white ">
              <FaUndo />
              <p>Reset Search Fields</p>
            </button>
            <button
              onClick={() => {
                if (userDataFromStorage.user_role === "admin") {
                  fetchData();
                } else {
                  fetchDataManager();
                }
              }}
              style={{ backgroundColor: coloredTheme }}
              className="flex justify-center items-center  rounded space-x-2 transition duration-[0.6s] px-[1rem] py-[0.5rem] text-white">
              <FiSearch />
              <p>Search</p>
            </button>
          </div>
        </div>
      </div>

      <div className="mt-8] bg-white p-[0.5rem]">
        {/* <p style={{ backgroundColor: coloredTheme }} className=' lg:w-[100%] md:w-[130%] w-[200%] py-[1rem] px-[0.5rem] text-white'>Total Claims reported below are MYR650</p> */}
        <div className="px-[0.5rem] overflow-x-scroll ">
          <p
            style={{ backgroundColor: coloredTheme }}
            className="p-[0.5rem] text-white">
            Total Claims Reported Below are : MYR {totalAmount}
          </p>

          <table className="lg:w-[100%] md:w-[130%] w-[200%]">
            <thead className="h-[6vh] ">
              <tr className="border border-gray-400">
                {userDataFromStorage.user_role === "admin" && (
                  <th className="text-center border-r  border-gray-400 px-[0.2rem]">
                    Claimer's Manager
                  </th>
                )}
                <th className="text-center border-r  border-gray-400 px-[0.2rem]">
                  Claimer Name
                </th>
                <th className="text-center border-r  border-gray-400 px-[0.2rem]">
                  Claim Date
                </th>
                <th className="text-center border-r  border-gray-400 px-[0.2rem]">
                  Claim Type
                </th>
                <th className="text-center border-r  border-gray-400 px-[0.2rem]">
                  Other Type
                </th>
                <th className="text-center   px-[0.2rem]">Amount</th>
              </tr>
            </thead>
            <tbody>
              {currentData.length
                ? currentData.map((x) => {
                    console.log("x", x);
                    let date = new Date(x?.claim_date);
                    let day = String(date?.getUTCDate()).padStart(2, "0");
                    let month = String(date?.getUTCMonth() + 1).padStart(
                      2,
                      "0"
                    );
                    let year = String(date?.getUTCFullYear());
                    let modifiedClaimDate = `${day}-${month}-${year}`;

                    return (
                      <tr
                        onClick={() => {
                          if (
                            userDataFromStorage.user_role === "admin" ||
                            userDataFromStorage.user_role === "manager"
                          ) {
                            setSelectedClaimData(x);
                            setOpenEdit(true);
                          }
                        }}
                        className="border border-gray-400">
                        {userDataFromStorage.user_role === "admin" && (
                          <td className="text-center border-l border-t border-r border-gray-400 px-[0.2rem]">
                            {x.managerName ? x.managerName : "---"}
                          </td>
                        )}
                        <td className="text-center border-l border-t border-r border-gray-400 px-[0.2rem]">
                          {x.agentName}
                        </td>
                        <td className="text-center border-l border-t border-r border-gray-400 px-[0.2rem]">
                          {modifiedClaimDate}
                        </td>
                        <td className="text-center border-l border-t border-r border-gray-400 px-[0.2rem]">
                          {x.claim_type}
                        </td>
                        <td className="text-center border-l border-t border-r border-gray-400 px-[0.2rem]">
                          {x.claim_reason
                            ? x.claim_reason
                            : x.other_type
                            ? x.other_type
                            : "N/A"}
                        </td>
                        <td>{x.amount}</td>
                      </tr>
                    );
                  })
                : "No Claim Record Found"}
            </tbody>
          </table>
        </div>

        <div className=" flex justify-end items-center mt-[2%] px-[0.8rem]">
          <Stack spacing={2}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(event, newPage) => setCurrentPage(newPage)}
              variant="outlined"
              shape="rounded"
            />
          </Stack>
        </div>
      </div>
      <div className="flex justify-start items-center space-x-4 mt-8 mb-8">
        {reconciliationDoneToday === true ? (
          ""
        ) : (
          <button
            style={{ backgroundColor: coloredTheme }}
            onClick={() => {
              setOpen(true);
              setOpenOtherReason(false);
            }}
            className="flex justify-center items-center space-x-2  text-purple-50 px-[1rem] py-[0.5rem] rounded  hover:bg-purple-50  hover:shadow-2xl hover:shadow-black">
            <RiSave2Fill className="text-2xl" />
            <p>New Claim</p>
          </button>
        )}
        <button
          style={{ backgroundColor: coloredTheme }}
          onClick={() => navigate("/home")}
          className="flex justify-center items-center space-x-2  text-green-50 px-[1rem] py-[0.5rem] rounded  hover:bg-green-50  hover:shadow-2xl hover:shadow-black ">
          <TbArrowBackUp className="text-2xl" />
          <p>Cancel</p>
        </button>
      </div>

      {/* ADD CLAIM MODAL */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="md:w-[50%] w-[95%]  rounded-lg bg-white absolute top-[8%] mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">Add Claim Details</p>
              </div>
              <Divider />

              <div className="p-[0.5rem]">
                {/* claim date (Required) */}
                <div className="grid grid-cols-4 ">
                  <label
                    htmlFor="date"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Claim Date</span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <input
                    type="date"
                    id="date"
                    onChange={(e) =>
                      setAddClaimData((prevState) => ({
                        ...prevState,
                        claim_date: e.target.value,
                      }))
                    }
                    value={addClaimData?.claim_date}
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter Claim Amount"
                  />
                </div>

                {/* claim type (Required)*/}
                <div className="grid grid-cols-4 mt-2 ">
                  <p className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Claim Type</span>
                    <span className="text-red-600 text-lg">*</span>
                  </p>

                  <div className="col-span-3">
                    <FormControl>
                      <RadioGroup
                        row
                        sx={{ width: "100%" }}
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        onChange={(e) => {
                          if (e.target.value === "other") {
                            setOpenOtherReason(true);
                            setAddClaimData((prevState) => ({
                              ...prevState,
                              claim_type: e.target.value,
                            }));
                          } else {
                            setOpenOtherReason(false);
                            setAddClaimData((prevState) => ({
                              ...prevState,
                              claim_type: e.target.value,
                            }));
                          }
                        }}
                        value={addClaimData.claim_type}>
                        <FormControlLabel
                          value="meals"
                          control={<Radio />}
                          label="Meals"
                        />
                        <FormControlLabel
                          value="mileage"
                          control={<Radio />}
                          label="Mileage"
                        />
                        <FormControlLabel
                          value="mobile"
                          control={<Radio />}
                          label="Mobile"
                        />
                        <FormControlLabel
                          value="cop"
                          control={<Radio />}
                          label="Cop"
                        />
                        <FormControlLabel
                          value="stationary"
                          control={<Radio />}
                          label="Stationary"
                        />
                        <FormControlLabel
                          value="salary"
                          control={<Radio />}
                          label="Salary"
                        />
                        <FormControlLabel
                          value="other"
                          control={<Radio />}
                          label="Other"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>

                {openOtherReason && (
                  <div className="grid grid-cols-4 mt-2">
                    <label
                      htmlFor="amount"
                      className="flex justify-start items-center col-span-1 space-x-1">
                      <span className="text-gray-700">Claim Type Reason</span>
                      <span className="text-red-600 text-lg">*</span>
                    </label>
                    <input
                      type="text"
                      id="reasonClaim"
                      value={claimReason}
                      onChange={(e) => setClaimReason(e.target.value)}
                      className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                      placeholder="Enter Claim Type Reason"
                    />
                  </div>
                )}

                {/* claim amount */}
                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="amount"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Claim Amount</span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <input
                    type="number"
                    id="amount"
                    onChange={(e) =>
                      setAddClaimData((prevState) => ({
                        ...prevState,
                        amount: e.target.value,
                      }))
                    }
                    value={addClaimData?.amount}
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter Claim Amount"
                  />
                </div>

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => setOpen(false)}
                    className="flex justify-center items-center space-x-2  text-purple-50 px-[1rem] py-[0.5rem] rounded  hover:bg-purple-50  hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={addClaimHandler}
                    // onClick={() => {
                    //   console.log("claim data:::::", addClaimData);
                    //   console.log("claim reason:::::", claimReason);
                    // }}
                    className="flex justify-center items-center space-x-2  text-green-50 px-[1rem] py-[0.5rem] rounded  hover:bg-green-50  hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Save</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      {/* EDIT CLAIM MODAL */}
      <Modal
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="md:w-[50%] w-[95%]  rounded-lg bg-white absolute top-[8%] mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">Edit Claim Details</p>
              </div>
              <Divider />

              <div className="p-[0.5rem]">
                {/* claim date (Required) */}
                <div className="grid grid-cols-4 ">
                  <label
                    htmlFor="date"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Claim Date</span>
                  </label>
                  <input
                    type="date"
                    id="date"
                    value={
                      selectedClaimData.claim_date
                        ? new Date(selectedClaimData.claim_date)
                            .toISOString()
                            .split("T")[0]
                        : ""
                    }
                    onChange={(e) =>
                      setSelectedClaimData((prevState) => ({
                        ...prevState,
                        claim_date: e.target.value,
                      }))
                    }
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter User Login Name"
                  />
                </div>

                {/* claim type (Required)*/}
                <div className="grid grid-cols-4 mt-2 ">
                  <p className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Claim Type</span>
                  </p>

                  <div className="col-span-3">
                    <FormControl>
                      <RadioGroup
                        row
                        sx={{ width: "100%" }}
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        onChange={(e) => {
                          if (e.target.value === "other") {
                            setOpenOtherReason(true);
                            setSelectedClaimData((prevState) => ({
                              ...prevState,
                              claim_type: e.target.value,
                            }));
                          } else {
                            setOpenOtherReason(false);
                            setSelectedClaimData((prevState) => ({
                              ...prevState,
                              claim_type: e.target.value,
                            }));
                          }
                        }}
                        value={selectedClaimData?.claim_type}>
                        <FormControlLabel
                          value="meals"
                          control={<Radio />}
                          label="Meals"
                        />
                        <FormControlLabel
                          value="mileage"
                          control={<Radio />}
                          label="Mileage"
                        />
                        <FormControlLabel
                          value="mobile"
                          control={<Radio />}
                          label="Mobile"
                        />
                        <FormControlLabel
                          value="cop"
                          control={<Radio />}
                          label="Cop"
                        />
                        <FormControlLabel
                          value="stationary"
                          control={<Radio />}
                          label="Stationary"
                        />
                        <FormControlLabel
                          value="salary"
                          control={<Radio />}
                          label="Salary"
                        />
                        <FormControlLabel
                          value="other"
                          control={<Radio />}
                          label="Other"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>

                {openOtherReason && (
                  <div className="grid grid-cols-4 mt-2">
                    <label
                      htmlFor="amount"
                      className="flex justify-start items-center col-span-1 space-x-1">
                      <span className="text-gray-700">Claim Type Reason</span>
                      <span className="text-red-600 text-lg">*</span>
                    </label>
                    <input
                      type="text"
                      id="reasonClaim"
                      value={claimReason}
                      onChange={(e) => setClaimReason(e.target.value)}
                      className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                      placeholder="Enter Claim Type Reason"
                    />
                  </div>
                )}

                {/* claim amount */}
                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="amount"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Claim Amount</span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <input
                    type="number"
                    id="amount"
                    onChange={(e) =>
                      setSelectedClaimData((prevState) => ({
                        ...prevState,
                        amount: e.target.value,
                      }))
                    }
                    value={selectedClaimData?.amount}
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter Claim Amount"
                  />
                </div>

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => setOpenEdit(false)}
                    className="flex justify-center items-center space-x-2  text-purple-50 px-[1rem] py-[0.5rem] rounded  hover:bg-purple-50  hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={editClaimHandler}
                    className="flex justify-center items-center space-x-2  text-green-50 px-[1rem] py-[0.5rem] rounded  hover:bg-green-50  hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Save</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      {/* CLAIM TYPE REASON MODAL */}
      {/* <Modal
        open={openOtherReason}
        onClose={() => setOpenOtherReason(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="w-[50%]  rounded-lg bg-white absolute top-[8%] mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">
                  Please Provide a Reason For Claim Type
                </p>
              </div>
              <Divider />

              <div className="p-[0.5rem]">
                <div className="grid grid-cols-4 ">
                  <label
                    htmlFor="claimReason"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Reason</span>
                  </label>
                  <input
                    type="text"
                    id="claimReason"
                    value={claimReason}
                    onChange={(e) => setClaimReason(e.target.value)}
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter Claim Reason for other type"
                  />
                </div>

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => {
                      setClaimReason("");
                      setOpenOtherReason(false);
                    }}
                    className="flex justify-center items-center space-x-2  text-purple-50 px-[1rem] py-[0.5rem] rounded  hover:bg-purple-50  hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => setOpenOtherReason(false)}
                    className="flex justify-center items-center space-x-2  text-green-50 px-[1rem] py-[0.5rem] rounded  hover:bg-green-50  hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Add Claim Type</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal> */}

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default Claims;
